export default __webpack_public_path__ + "static/media/Ubuntu-M.446e34b7.woff";